import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fyb6rnmnyf: FaireBrandEntity = {
  token: "b_fyb6rnmnyf",
  type: "brand",
  name: "Putnam Design LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/69ee3316e794dd8ceaca2f15f5ae88d444fd179977df54fea20357f4178156b4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0f12028ba4347ff9832d71a660241ad9f5814260548ae437338328d5d1c157a8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/69ee3316e794dd8ceaca2f15f5ae88d444fd179977df54fea20357f4178156b4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0f12028ba4347ff9832d71a660241ad9f5814260548ae437338328d5d1c157a8.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 20,
  rating: 5,
  reviewCount: 30,
  isInsider: true,
  description:
    "Putnam Design pours scented candles the way florists build bouquets — one stem at a time.\n\nEach candle is an elemental fragrance note: rose, tomato leaf, palo santo, smoke. No pyramids, no filler. Bold, direct scent — designed to stand alone or burned together to create a custom atmosphere.\n\nLight one and the room shifts. Light two or three, and you’ve made something personal. Something only you could make. \n\nFounded by Taylor Putnam — formerly of the storied floral studio Putnam & Putnam — the brand brings a decade of floristry into flame. Shape, color, and atmosphere now lives in wax and wick.\n\nThe custom artwork seen on each candle is illustrated using crayon and inspired by folk art, fairy tales, and scent memories: worms with crowns, citrus with teeth, Marie Antoinette in bones. The spirit is vibrant, surreal, and never serious.\n\nPutnam Design is beyond home fragrance. It’s a modular scent system wrapped in irreverence — one note, but a myriad ways to make it uniquely yours.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:56.173Z",
    importedBy: "entity-db-cli",
  },
};
